import { Box, BoxProps, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';

/** Brand purple used for Content AI badges. */
const CONTENT_BADGE_PURPLE = '#AF52DE';

interface ContentBadgeProps extends Omit<BoxProps, 'sx'> {
  children: ReactNode;
  icon?: ReactNode;
  sx?: SxProps<Theme>;
}

export function ContentBadge({ children, icon, sx, ...props }: ContentBadgeProps) {
  return (
    <Box
      sx={[
        (theme) => ({
          display: 'inline-flex',
          padding: '4px 8px',
          alignItems: 'center',
          gap: '4px',
          borderRadius: '6px',
          border: `1px solid ${CONTENT_BADGE_PURPLE}`,
          background: theme.palette.mode === 'dark' ? 'rgba(175, 82, 222, 0.15)' : '#FDEDFF',
        }),
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
      {...props}
    >
      {icon}
      <Box
        component="span"
        sx={{
          color: CONTENT_BADGE_PURPLE,
          typography: 'caption',
          fontFamily: 'Inter',
          fontWeight: 600,
          lineHeight: '20px',
          letterSpacing: '-0.072px',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
